import _AlertInformationIcon from "@adsk/alloy-react-icon/es/lib/AlertInformationIcon";
import _styled from "styled-components";
const _excluded = ["className", "style", "renderIcon", "size", "placement", "message", "container", "containerPadding", "shouldOpenOnClick", "onClick", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop, useOnClickOutside } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Flyout from './Flyout';
const InfoPopover = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      renderIcon,
      size,
      placement,
      message,
      container,
      containerPadding,
      shouldOpenOnClick,
      onClick,
      variant
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const overlayRef = useRef(null);
  const targetRef = useRef(null);
  const [isClicked, setIsClicked] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const isOpen = isClicked || isMouseOver;
  const variantContainerPadding = variant === Flyout.VARIANTS.DARK ? '8px 12px' : '16px';
  let hideTimeout;
  function handleClickOutside() {
    setIsClicked(false);
    setIsMouseOver(false);
  }
  function onClickClose(e) {
    if (!isClicked && shouldOpenOnClick) {
      setIsClicked(true);
    }
    if (onClick) {
      onClick(e);
    }
  }
  function onMouseEnter() {
    if (!isMouseOver) {
      setIsMouseOver(true);
    }
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }
  }
  function onMouseLeave() {
    hideTimeout = setTimeout(() => {
      if (isMouseOver) {
        setIsMouseOver(false);
      }
    }, 100);
  }
  useOnClickOutside(Boolean(shouldOpenOnClick && isClicked), handleClickOutside, [targetRef, overlayRef]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    className: className,
    onClick: onClickClose,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    $_css: [style]
  }, /*#__PURE__*/React.createElement(Flyout, _extends({
    overlayRef: overlayRef,
    content: message,
    show: isOpen,
    container: container,
    containerPadding: containerPadding || variantContainerPadding,
    placement: placement,
    delayHide: 1000,
    delayShow: 1000,
    variant: variant
  }, props), renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon({
    ref: targetRef,
    size,
    style: {
      cursor: 'pointer',
      color: theme.tokens.colors.icon.information.value
    }
  })));
});
InfoPopover.displayName = 'InfoPopover';
InfoPopover.defaultProps = {
  onClick: noop,
  shouldOpenOnClick: true,
  renderIcon: p => /*#__PURE__*/React.createElement(_AlertInformationIcon, p),
  size: 16,
  placement: Flyout.PLACEMENTS.BOTTOM
};
InfoPopover.propTypes = {
  /**
   * className to add to the InfoPopover component
   */
  className: PropTypes.string,
  /**
   * style to add to the InfoPopover component
   */
  style: stylePropType,
  /**
   * The icon square size
   */
  size: PropTypes.number,
  /**
   * A node to be shown on hover.
   */
  message: PropTypes.any.isRequired,
  /**
   * Optional function to run when the info icon is pressed. Passes the click event target
   */
  onClick: PropTypes.func,
  /**
   * Optional parameter to specify if InfoPopover will stay opened on click.
   */
  shouldOpenOnClick: PropTypes.bool,
  /**
   * The icon to be displayed for the info
   */
  renderIcon: PropTypes.func,
  /**
   * The icon to be displayed for the info
   */
  placement: PropTypes.oneOf(Object.values(Flyout.PLACEMENTS)),
  /**
   * Control how much space there is between the edge of the boundary element and overlay.
   */
  containerPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * InfoPopover variant
   */
  variant: PropTypes.oneOf(Object.values(Flyout.VARIANTS))
};
export default Object.assign(InfoPopover, {
  VARIANTS: Flyout.VARIANTS,
  PLACEMENTS: Flyout.PLACEMENTS,
  TRIGGER_EVENTS: Flyout.TRIGGER_EVENTS,
  TRIGGER_TARGETS: Flyout.TRIGGER_TARGETS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "InfoPopover___StyledDiv",
  componentId: "sc-151xikh-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=InfoPopover.js.map